<div class="table-toolbar">
  <div class="search-container">
    <input
      type="text"
      maxlength="100"
      class="search-input"
      [placeholder]="placeholder()"
      [(ngModel)]="value"
      (input)="onInput()"
      (keyup.enter)="onSearch()"
    />

    <button type="button" class="search-button" title="Buscar" (click)="onSearch()">
      <i class="fa-solid fa-magnifying-glass"></i>
    </button>
  </div>
</div>
